<mat-dialog-content>
  <div class="modalWrapper">
    <button class="cmn-close" (click)="onNoClick()"></button>

    <div class="headerClass">
      <h3>
        {{
        data.type === 'add-plan'
        ? 'Add Plan'
        : data.type === 'add-feature'
        ? 'Add Feature'
        : 'Edit Feature'
        }}
      </h3>
    </div>

    <form [formGroup]="documentForm">
      <div class="form-wrapper">
        <label>{{
          data.type === 'add-plan' ? 'Plan Name' : 'Feature Name'
          }}</label>
        <mat-form-field appearance="fill">
          <input matInput formControlName="inputValue" placeholder="Enter {{
      data.type === 'add-plan' ? 'plan name' : 'feature name'
    }}" />

          <mat-error *ngIf="inputCtrl?.touched && inputCtrl?.hasError('pattern')">
            Only letters and numbers are allowed
          </mat-error>

          <mat-error *ngIf="inputCtrl?.touched && inputCtrl?.hasError('required')">
            {{ data.type === 'add-plan' ? 'Plan name' : 'Feature name' }} is required
          </mat-error>

          <mat-error *ngIf="inputCtrl?.touched && inputCtrl?.hasError('minlength')">
            Minimum 2 characters required
          </mat-error>

          <mat-error *ngIf="inputCtrl?.touched && inputCtrl?.hasError('maxlength')">
            Maximum 50 characters allowed
          </mat-error>
        </mat-form-field>

      </div>

      <div class="btn-wrapper">
        <button type="button" class="cmn-cancel-btn" (click)="onCancel()">
          Cancel
        </button>

        <button type="submit" class="cmn-next-btn" (click)="onSave()">
          {{ data.type === 'edit-feature' ? 'Update' : 'Save' }}
        </button>

      </div>
    </form>
  </div>
</mat-dialog-content>
